/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faDeleteLeft,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import useAllCandidates from "./useAllCandidates";
import CandidateSearch from "./components/CandidateSearch";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import { fixImageUrl } from "../../../_helpers/fixImageUrl";
import MainLayout from "../../Common/MainLayout";
import { Spinner } from "react-bootstrap";
export default (props) => {
  const {
    skillsTagsAdded,
    suggestedCandidates,
    candidateSelectedSkill,
    showSearch,
    searchInputRef,
    showSkillSearch,
    suggestedCandidatesLoading,
    searchInputSkillsRef,
    onSearchSkillChange,
    onSkillSearch,
    onSearch,
    onSearchInputChange,
    onCandidateJobsSkillsChange,
    onCandidateSkillUnselectClick,
    onViewCandidateProfileClick,
    onViewAllAppliedCandidates,
    onHandleClearTags,
    checkSelectedTag,
  } = useAllCandidates(props);

  return (
    <MainLayout activeMenuItem="candidate" pageName="All Candidates">
      <div className="container">
        <div className="row no-gutters">
          <div className="col-12 pt-0 pt-md-2 mb-4 mb-md-0">
            <div className="row">
              <div className="col-md-6">
                <div className="search mb-2 justify-content-between align-items-center">
                  <div className="search-box input-group  align-items-center h-auto bg-white border border-radius-10">
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent"
                      placeholder="Search Candidates"
                      onChange={(e) => onSearchInputChange(e)}
                      ref={searchInputRef}
                      style={{ height: "46px" }}
                    />
                    <div className="input-group-append">
                      {showSearch ? (
                        <button
                          className="btn p-2"
                          type="button"
                          onClick={onSearch}
                        >
                          <FontAwesomeIcon
                            icon={faDeleteLeft}
                            className="ml-2"
                          />
                        </button>
                      ) : (
                        <button className="btn p-2" type="button">
                          <img
                            src="../assets/images/search-icon.png"
                            alt="search"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex mb-2 justify-content-between">
                  <div className="search-box input-group border border-radius-10 bg-white">
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent"
                      placeholder="Search Skills"
                      onChange={(e) => onSearchSkillChange(e)}
                      ref={searchInputSkillsRef}
                      style={{ height: "46px" }}
                    />
                    <div className="input-group-append">
                      {showSkillSearch ? (
                        <button
                          className="btn p-2"
                          type="button"
                          onClick={onSkillSearch}
                        >
                          <FontAwesomeIcon
                            icon={faDeleteLeft}
                            className="ml-2"
                          />
                        </button>
                      ) : (
                        <button className="btn p-2" type="button">
                          <img
                            src="../assets/images/search-icon.png"
                            alt="search"
                          />
                        </button>
                      )}
                    </div>
                  </div>
                  {Array.isArray(candidateSelectedSkill) &&
                    candidateSelectedSkill.length ? (
                    <button
                      className="btn py-1 mb-1 ml-3 btn-primary border-radius-10"
                      onClick={onHandleClearTags}
                    >
                      Clear
                    </button>
                  ) : null}
                </div>
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={5}
                  modules={[FreeMode, Navigation]}
                  className="custom-tab-slider"
                  navigation={true}
                  loop={true}
                >
                  {skillsTagsAdded &&
                    Array.isArray(skillsTagsAdded) &&
                    skillsTagsAdded.map((tag, index) => (
                      <SwiperSlide>
                        <div
                          className={`h4 py-1 border rounded-pill font-weight-normal cursor-pointer ${checkSelectedTag(tag)
                              ? "bg-primary-light border-primary text-primary"
                              : "text-grey-4 bg-white"
                            } px-2 mr-2 text-capitalize d-flex`}
                          key={index}
                        >
                          <div
                            onClick={() => onCandidateJobsSkillsChange(tag)}
                            className="d-flex flex-wrap pr-1"
                          >
                            {tag?.skill}
                          </div>
                          {checkSelectedTag(tag) ? (
                            <button
                              className="bg-transparent border-0 position-relative"
                              style={{ zIndex: 2 }}
                              onClick={() => onCandidateSkillUnselectClick(tag)}
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </button>
                          ) : null}
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
                <Swiper
                  slidesPerView={"auto"}
                  spaceBetween={5}
                  modules={[FreeMode, Navigation]}
                  className="custom-tab-slider"
                  navigation={true}
                  loop={true}
                >
                  {Array.isArray(candidateSelectedSkill) &&
                    candidateSelectedSkill.map((tag, index) => (
                      <SwiperSlide>
                        <div
                          className={`h4 py-1 border rounded-pill font-weight-normal cursor-pointer ${checkSelectedTag(tag, true)
                              ? "bg-primary-light border-primary text-primary"
                              : "text-grey-4 bg-white"
                            } px-2 mr-2 text-capitalize d-flex`}
                          key={index}
                        >
                          <div
                            onClick={() =>
                              onCandidateJobsSkillsChange(tag, true)
                            }
                            className="d-flex flex-wrap pr-1"
                          >
                            {tag}
                          </div>
                          {checkSelectedTag(tag, true) ? (
                            <button
                              className="bg-transparent border-0 position-relative"
                              style={{ zIndex: 2 }}
                              onClick={() =>
                                onCandidateSkillUnselectClick(tag, true)
                              }
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </button>
                          ) : null}
                        </div>
                      </SwiperSlide>
                    ))}
                </Swiper>
              </div>
            </div>
          </div>
          <div className="col-12">
            {/* {showSearch ? (
              <CandidateSearch
                candidateSearch={candidateSearch}
                candidateLoading={candidateLoading}
                onViewCandidateProfileClick={onViewCandidateProfileClick}
              />
            ) :  */}
            {suggestedCandidatesLoading ? (
              <div className="d-flex justify-content-center align-items-center w-100 mt-5">
                <Spinner animation="border" variant="primary" />
              </div>
            ) :
              Array.isArray(suggestedCandidates) &&
                suggestedCandidates &&
                suggestedCandidates.length ? (
                <div className="job-listing">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h2 className="d-inline-block">
                      Showing {suggestedCandidates && suggestedCandidates.length}{" "}
                      Candidates
                    </h2>
                  </div>
                  <div className="row">
                    {Array.isArray(suggestedCandidates) &&
                      suggestedCandidates.map((item) => (
                        <div className="col-lg-6 mb-3 mt-3 mt-md-0">
                          <div className="job-box d-flex flex-column h-100 p-3 my-0 bg-white border position-relative border-radius-10">
                            <div className="mb-3">
                              <div className="d-flex mb-3 align-items-center">
                                <img
                                  src={
                                    item?.user_details?.user_meta_info
                                      ?.profile_image
                                      ? fixImageUrl(
                                        item?.user_details?.user_meta_info
                                          ?.profile_image
                                      )
                                      : "/assets/images/user.png"
                                  }
                                  alt="candidate"
                                  className="mr-3 border-radius-10"
                                  style={{
                                    height: "55px",
                                    width: "55px",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                  }}
                                />
                                <div className="job-info">
                                  <h3
                                    className="font-weight-bold mb-1 text-capitalize cursor-pointer text-primary"
                                    onClick={() =>
                                      onViewCandidateProfileClick(
                                        item?.user_details &&
                                        item.user_details?.hash_id
                                      )
                                    }
                                  >
                                    {item?.user_details &&
                                      item.user_details?.full_name}
                                  </h3>
                                  <p className="text-grey-4">{item.headline}</p>
                                </div>
                              </div>
                              <div className="d-flex align-items-center justify-content-between  mb-1">
                                <p className="mr-2  text-capitalize font-weight-medium">
                                  {item?.city_name ? (
                                    <span className="text-dark border rounded-pill px-2 py-1 font-weight-medium">
                                      {item?.state_name}
                                      {item.state_name ? "," : null}{" "}
                                      <span className="text-uppercase">
                                        {item?.country_name}
                                      </span>
                                    </span>
                                  ) : (
                                    <span className="text-grey-4 font-weight-400">
                                      Location Not Mentioned
                                    </span>
                                  )}
                                </p>
                              </div>
                              <p className="mb-0 mr-2">
                                <div className="d-flex flex-wrap align-items-center mt-2">
                                  {item?.skills &&
                                    Array.isArray(item?.skills) &&
                                    item.skills.map((tag) => (
                                      <>
                                        {tag?.is_primary === true ? (
                                          <div
                                            className={
                                              "bg-grey-3 border text-dark rounded-lg px-2 mr-2 text-capitalize mb-1 fs-smallest"
                                            }
                                            key={tag?.id}
                                          >
                                            {tag?.skill_name}
                                          </div>
                                        ) : null}
                                      </>
                                    ))}
                                </div>
                              </p>
                            </div>
                            <div className="job-bottom d-flex align-items-center justify-content-between mt-auto border-top pt-3">
                              <p className="mb-0 mr-2 text-muted fs-smallest">
                                <span className="font-weight-medium">
                                  Expected Salary:{" "}
                                </span>
                                <span className="text-uppercase">
                                  {item?.payment_currency} {item?.expected_salary}
                                </span>
                              </p>
                              <button
                                className="btn text-primary p-0"
                                onClick={() =>
                                  onViewCandidateProfileClick(
                                    item?.user_details &&
                                    item.user_details?.hash_id
                                  )
                                }
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center
                justify-content-center flex-column py-4"
                >
                  <img src="/assets/images/empty-state.svg" alt="empty" />
                  <h4 className="font-weight-bold mb-1 mt-2">
                    No Candidates Found
                  </h4>
                </div>
              )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};
